export default "__VITE_ASSET__DWUgFmLQ__"